import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
type CTAButtonProps = {
  label: string;
  id?: string;
  compact?: boolean;
  className?: string;
};
export function CTAButton({
  label,
  id,
  compact = false,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      value: 27,
      currency: 'USD'
    });
  };
  return <a id={id} href={CHECKOUT_URL} onClick={handleClick} className={`group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-pulse text-center font-display font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_12px_30px_-10px_rgba(225,29,46,0.75)] ring-1 ring-inset ring-white/20 transition-[transform,background-color] duration-150 ease-out hover:bg-pulse-600 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold ${compact ? 'px-5 py-3.5 text-[15px]' : 'px-6 py-5 text-[17px] sm:text-lg'} ${className}`} data-id="element-42" data-mp="2tx030seyl0u4">
      <span className="text-balance" data-id="element-43" data-mp="1d9yjvq7lru6k">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-44" data-mp="1darretedynpr" />
    </a>;
}